<div class="app-chip">
	<p [ngClass]="[chipCssClass, fontCssClass]">
		<ng-content></ng-content>
	</p>
</div>
